<template>
  <div class="home-page">
    <!-- <game-header :bannerCode="bannerCode"></game-header> -->
    <video autoPlay muted loop src="../assets/bg-site.webm" type="video/webm" class='site-bg-video' />
     <new-home-block></new-home-block>
     <!-- <el-backtop target="#app" :bottom="15">
      <div class="back-top">
        <i class="el-icon-arrow-up"></i>
        <p>{{$t('dialog.BackToTop')}}</p>
      </div>
    </el-backtop> -->
    <home-pendant></home-pendant>
    <home-center></home-center>
  </div>
</template>

<script>
/*eslint-disable*/
  import {mapActions, mapState, mapMutations} from 'vuex'
  import {common, commonApi} from '@/common/index';
  import { MessageBox,Conf } from 'element-ui';
  // import GameHeader from '../components/game-header/game-header';
  import Jackpot from '../components/jackpot/index'
  import newHomeBlock from '../components/new-home/new-home2'
  // import * as bannerCode from '../assets/js/bannerCode'
  import HomePendant from '../components/pendant/home-pendant'
  import HomeCenter from "../components/pendant/home-center";

  export default {
    name: 'HOME',
    components: {
      HomePendant,
      Jackpot,
      newHomeBlock,
      HomeCenter
    },
    data() {
      return {
        // bannerCode: bannerCode['HomeBannerList'],
        // HomeImageNavList: bannerCode['HomeImageNavList'],
        // secondNav: []
      }
    },
    computed: {
      ...mapState({
        UUID: state => state.UUID,
        isLogin: state => state.isLogin,
        frontType: state => state.frontType,
        appJump: state => state.linkList.appJump
      })
    },
    // watch:{
    //   $route: {
    //     immediate: true,
    //     handler(newV, oldV) {
    //       let agentCode = this.$route.query.agentCode;
    //       if (agentCode) {
    //         this.$router.push("/");
    //         this.setshowloginfloat(true);
    //         this.$Cookies.set('agentCode', agentCode, { expires: 1 })
    //       }
    //     },
    //   },
    // },
    methods: {
      ...mapMutations(['TOP_VIEW']),
      ...mapActions(['getFirstInfo', 'IS_LOGIN_FOCUS']),
      // getImageNavList() {
      //   commonApi.HOMEBEFORE.fetchImg(this.HomeImageNavList)
      //     .then(data=>{
      //       this.secondNav = data;
      //     })
      //     .catch(err=>{})
      // },
      goHref(url) {
        let path = common.goHref(url)
        if(path) {
          this.$router.push({path})
        }
      }
    },
    created() {
      // this.getImageNavList()
    }
  }
</script>

<style scoped lang="scss">
  // @import '../style/mixins';
  .home-page{
    width:100%;
    margin-top:0px;
    // position: relative;
    // z-index:1;
   .site-bg-video{
    position: fixed;
    width: 100%;
    height:150%;
    object-fit: cover;
    margin: 0 auto;
    display: block;
    z-index: 0;
    left:-10px;
    top: -138px;
   }
    .el-backtop{ 
      right:50%!important;
      margin-right:-95px;
    }
    .back-top{
      width: 190px;
      height: 60px;
      background-color: #bebf01;
      box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      font-family: Roboto-Regular;
      font-size: 14px;
      -webkit-text-stroke:.5px;
      color: #fff;
      text-align: center;
      i{
        font-weight: 600;
        font-size:16px;
        margin:10px 0 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/build902/views/HOME.vue